import React from 'react';
import { Modal, Form } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
  useModalState,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownEndDateChange } from '../../api';
import { ShutdownField } from '../../../common/ui/ShutdownField';
import {
  fieldNames,
  changeModalWithInfoBodyStyle,
} from '../../../common/config';
import NotificationSendingAlert, {
  notificationSendingAlertMsgTypes,
} from '../../../../../shared/ui/NotificationSendingAlert/NotificationSendingAlert';

const ModalContainer = ({ form }) => {
  const { type, initialValues: shutdown = {} } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => dispatch({ type: modalActionTypes.resetModalData });

  const { change, loading } = useShutdownEndDateChange();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const data = {
          value: formValues[fieldNames.endDate]
            .clone()
            .set({ second: 0 })
            .utc()
            .format(),
        };
        await change({ shutdownId: shutdown.alertId, data });
        close();
      }
    });
  };

  return (
    <Modal
      visible={type === modalTypes.changeShutdownEndDate}
      onCancel={close}
      onOk={handleSubmit}
      title={`${shutdown.endDate ? 'Изменить' : 'Добавить'} дату окончания`}
      destroyOnClose
      confirmLoading={loading}
      bodyStyle={changeModalWithInfoBodyStyle}
    >
      <NotificationSendingAlert
        messageType={notificationSendingAlertMsgTypes.cityServices}
      />
      <Form colon={false}>
        <ShutdownField
          name={fieldNames.endDate}
          form={form}
          initialValue={shutdown.endDate}
          editMode
          shutdown={shutdown}
        />
      </Form>
    </Modal>
  );
};

const ChangeModal = Form.create({ name: 'change_shutdown_end_date' })(
  ModalContainer
);

export default ChangeModal;
